import React from "react";
import BalanceOverview from './BalanceOverview'
import {Container, Header} from 'semantic-ui-react';
import {useParams} from "react-router";


export default function Balance(props) {
    let {year} = useParams()

    return (
        <Container style={{marginTop: '7em'}}>
            <Header>Balance {year}</Header>
            <p>Balance ist ein Deckungsbeitrag. Berücksichtigt werden Rechnungen und Gutschriften.</p>
            <pre>balance = (sum_vk_netto_total - sum_ek_netto_total - operating_costs_month)</pre>
            <BalanceOverview year={year}/>
        </Container>
    )
}


